import { User } from "@/types";
import { post, get } from "./client";

export interface LoginCredentials {
  username: string;
  password: string;
}

export async function login(credentials: LoginCredentials): Promise<User> {
  return post<User>("/auth/login", credentials);
}

export async function logout(): Promise<void> {
  await post("/auth/logout", {});
}

export async function getMe(): Promise<User> {
  return get<User>("/auth/me");
}
